// Copyright (C) 2021 Bystronic Laser AG

export enum DataPlatformActionEnum {
  Restart = 'restart_flows',
}
